import { render, staticRenderFns } from "./formUpload.vue?vue&type=template&id=a385fca4&"
import script from "./formUpload.vue?vue&type=script&lang=js&"
export * from "./formUpload.vue?vue&type=script&lang=js&"
import style0 from "./formUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports